import styled from 'styled-components';
import { Banner, getSpacingToken } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithAccountId } from '@mews-commander/types';
import { AccountType } from '@mews-commander/data-access';
import { getFullName } from '@mews-commander/utils';
import { useGetAccount } from '../../../../accounts';
import { useGetSettlements } from './queries';

const SettlementsScheduledBannerWrapper = styled.div`
    margin-bottom: ${getSpacingToken('200')}px;
`;

export const SettlementsScheduledBanner = ({ accountId }: WithAccountId) => {
    const { data: account } = useGetAccount({ accountId });
    const { data: settlements = [] } = useGetSettlements({ accountId });

    if (!account || settlements.length === 0) {
        return null;
    }

    const { discriminator, value } = account.data;

    return (
        <SettlementsScheduledBannerWrapper>
            <Banner
                primaryText={
                    <LocalizedText
                        textKey={TextKey.ScheduledSettlementsInfoMessage}
                        substitutes={{
                            customer: discriminator === AccountType.Customer ? getFullName(value) : value.name,
                        }}
                    />
                }
                variant="info"
            />
        </SettlementsScheduledBannerWrapper>
    );
};
